<template>
  <div class="login-success-box show-flex-box-r">
    <dl class="show-flex-box-c">
      <dt class="show-flex-box-c">
        <span class="show-flex-box-r" @click="tabToPersonalCenter">
          <img :src="userInfo.avatar" alt="德阳经开科创" v-if="userInfo.avatar" draggable="false">
        </span>
        <strong @click="tabToPersonalCenter">{{userInfo.nickname}}</strong>
      </dt>
      <dd class="show-flex-box-c">
        <div class="show-flex-box-c">
          <span class="show-flex-box-r" @click="tabToMarsCourse">
            <strong>进入工作区</strong>
          </span>
          <h1 class="show-flex-box-r" @click="logout">退出账号</h1>
        </div>
      </dd>
    </dl>
  </div>
</template>

<script>
import regex from "@/filter/regex";

export default {
  name: "login_success_cpn",
  data() {
    return {
      userInfo: {}
    };
  },
  created() {
    this.isGetUserInfo();
  },
  computed: {
    listenToken: function() {
      return this.$store.state.token;
    },
    listenUserInfo: function() {
      return this.$store.state.user;
    }
  },
  methods: {
    tabToPersonalCenter: function() {
      let toWhere = "/personal/set/home/personal";
      this.$router.push({ path: toWhere });
    },
    isGetUserInfo: function() {
      let userToken = this.$store.state.token;
      let tokenStatus = regex.isTrueResult(userToken);

      if (tokenStatus) {
        this.getUserInfo();
        this.checkUserStatus();
      }
    },
    checkUserStatus: function() {
      let userStore = this.$store.state.user;
      let userStatus = regex.isTrueResult(userStore);

      if (userStatus) {
        this.logined = regex.isTrueResult(this.$store.state.loginStatus);
        this.userInfo = this.formatUserInfoByType(userStore);
      } else {
        this.userInfo = {};
        this.logined = regex.isTrueResult(this.$store.state.loginStatus);
      }
    },
    //用户信息数据类型转换
    formatUserInfoByType: function(userStore) {
      let dataType = typeof userStore;
      let userObj = userStore;

      // if (dataType == 'string') {
      //   userObj = $.parseJSON(userStore);
      // }

      return userObj;
    },
    getUserInfo: function() {
      let vSelf = this;

      this.$client
        .getUserInfo()
        .then(res => {
          if (res.code === "200" || res === 200) {
            // console.log(JSON.stringify(res));
            vSelf.userInfo = res.data;
            let curUserInfo = vSelf.saveUserInfo(res.data);
            vSelf.$store.commit("GET_USER", curUserInfo);
          }
        })
        .catch(err => {});
    },
    // 保存用户信息
    saveUserInfo: function(userObj) {
      let userInfo;

      userInfo = {
        nickname: userObj.nickname,
        avatar: userObj.avatar,
        is_agents: regex.isTrueResult(userObj.is_agents),
        is_teacher: regex.isTrueResult(userObj.is_teacher),
        can_view_organ_post: regex.isTrueResult(userObj.can_view_organ_post),
        last_invoice_config: userObj.last_invoice_config
      };

      return userInfo;
    },
    logout: function() {
      this.$store.commit("LOGOUT");
      this.$router.push({ path: "/web/index" });
      this.$client
        .userlogout()
        .then(res => {
          // console.log(JSON.stringify(res));
          if (res.code == 200 || res.code == "200") {
            this.$emit("pass-logout", false);
          }
        })
        .catch(err => {
          console.log(JSON.stringify(err));
        });
    },
    tabToMarsCourse: function() {
      // let routeData = this.$router.resolve({
      //   name: "ins_course_home",
      //   path: "/mars_box_ins/ins_entrance/ins_course_home/ins/ins_course_home"
      // });
      // window.open(routeData.href, "_blank");

      const { href } = this.$router.resolve({
        // name: "ins_course_home",
        path: "/mars_box_ins/ins_entrance/ins_course_home/ins/ins_course_home",
        query: {}
      });
      // console.log(JSON.stringify(href));
      window.open(href, "_blank");
    }
  },
  watch: {
    listenToken: function() {
      let tokenStatus = regex.isTrueResult(this.listenToken);
      if (tokenStatus) {
        this.getUserInfo();
      }
    },
    listenUserInfo: function() {
      this.checkUserStatus();
    }
  }
};
</script>

<style lang="less" scoped>
//公共字体样式  start
.login-success-font-style( @size; @weight; @height; @color ) {
  display: block;
  font-size: @size;
  font-weight: @weight;
  line-height: @height;
  color: @color;
  word-break: break-all;
}

.login-success-box {
  width: 100%;
  justify-content: center;
  & > dl {
    width: 100%;
    & > dt {
      width: 100%;
      height: 188px;
      align-items: center;
      justify-content: center;
      & > span {
        width: 90px;
        height: 90px;
        overflow: hidden;
        margin-bottom: 21px;
        border-radius: 100%;
        box-shadow: 0px 1px 1px #dedede;
        cursor: pointer;
        & > img {
          display: block;
          width: 100%;
          flex-grow: 1;
          object-fit: cover;
        }
      }
      & > strong {
        .login-success-font-style(18px; 500; auto; #191d21);
        cursor: pointer;
      }
    }
    & > dd {
      width: 100%;
      align-items: center;
      padding-bottom: 30px;
      & > div {
        width: 100%;
        & > span {
          width: 100%;
          height: 40px;
          justify-content: center;
          align-items: center;
          background: #ff7800;
          border-radius: 5px;
          cursor: pointer;
          & > strong {
            .login-success-font-style(18px; 500; 40px; #fff);
          }
        }
        & > h1 {
          padding-top: 18px;
          .login-success-font-style(14px; bold; auto; #191d21);
          align-self: flex-end;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login_success_cpn.vue